import { createFeatureGuard } from './createFeatureGuard';
import { Feature } from './Constants';

export const dataExportGuard = createFeatureGuard(Feature.DataExport);